import React from "react";
import "./css/Lastpage.css";
import s1 from "./Images/s1.jpg";
import s2 from "./Images/s2.jpg";
import s3 from "./Images/s3.jpg";
import s4 from "./Images/s4.jpg";
import s5 from "./Images/s5.jpg";
import s6 from "./Images/s6.jpg";

import msg from "./Images/email.png";
import call from "./Images/phone.png";
import location from "./Images/location.png";

export const LastPage = () => {
  return (
    <div className="lastpage">
      <div className="title">--Best services--</div>
      <div className="title2">Excellence in Every Banking Service</div>
      <div className="w-full flex flex-wrap justify-center">
        <div className="square md:w-[25%] bg-[#F7F7F7] shadow-xl md:m-10 md:flex md:flex-col md:justify-center md:items-center md:p-6 p-2 text-[#67c6e6]">
          <img
            src={s1}
            alt=""
            className="md:rounded-full w-[100px] h-[100px] rounded-full md:w-[200px] md:h-[200px] object-cover"
          />
          <h3 className="font-semibold mt-4 text-sm md:text-lg ">
            Saving Group Loan
          </h3>
          <p className="md:text-[12px] text-[9px] tracking-wide md:tracking-normal md:text-left py-2 px-4 hidden md:block text-gray-500">
            Discover the difference of banking with BGS, where our values of
            integrity, respect, and excellence drive everything we do
          </p>
        </div>
        <div className="square  md:w-[25%] bg-[#F7F7F7] shadow-xl md:m-10 md:flex md:flex-col md:justify-center md:items-center md:p-6 p-2">
          <img
            src={s2}
            alt=""
            className="md:rounded-full w-[100px] h-[100px] rounded-full md:w-[200px] md:h-[200px] object-cover"
          />
          <h3 className="font-semibold mt-4 text-sm md:text-lg text-[#67c6e6]">
            Business Loan
          </h3>
          <p className="md:text-[12px] text-[9px] tracking-wide md:tracking-normal md:text-left py-2 px-4 hidden md:block  text-gray-500">
            Discover the difference of banking with BGS, where our values of
            integrity, respect, and excellence drive everything we do
          </p>
        </div>
        <div className="square md:w-[25%] bg-[#F7F7F7] shadow-xl md:m-10 md:flex md:flex-col md:justify-center md:items-center md:p-6 p-2">
          <img
            src={s3}
            alt=""
            className="md:rounded-full w-[100px] h-[100px] rounded-full md:w-[200px] md:h-[200px] object-cover"
          />
          <h3 className="font-semibold mt-4 text-sm md:text-lg text-[#67c6e6]">
            Home Loan
          </h3>
          <p className="md:text-[12px] text-[9px] tracking-wide md:tracking-normal md:text-left py-2 px-4 hidden md:block  text-gray-500">
            Discover the difference of banking with BGS, where our values of
            integrity, respect, and excellence drive everything we do
          </p>
        </div>
        <div className="square  md:w-[25%] bg-[#F7F7F7] shadow-xl md:m-10 md:flex md:flex-col md:justify-center md:items-center md:p-6 p-2">
          <img
            src={s4}
            alt=""
            className="md:rounded-full w-[100px] h-[100px] rounded-full md:w-[200px] md:h-[200px] object-cover"
          />
          <h3 className="font-semibold mt-4 text-sm md:text-lg text-[#67c6e6]">
            Daily Deposit Loan
          </h3>
          <p className="md:text-[12px] text-[9px] tracking-wide md:tracking-normal md:text-left py-2 px-4 hidden md:block  text-gray-500">
            Discover the difference of banking with BGS, where our values of
            integrity, respect, and excellence drive everything we do
          </p>
        </div>
        <div className="square  md:w-[25%] bg-[#F7F7F7] shadow-xl md:m-10 md:flex md:flex-col md:justify-center md:items-center md:p-6 p-2">
          <img
            src={s5}
            alt=""
            className="md:rounded-full w-[100px] h-[100px] rounded-full md:w-[200px] md:h-[200px] object-cover"
          />
          <h3 className="font-semibold mt-4 text-sm md:text-lg text-[#67c6e6]">
            Gold Loan
          </h3>
          <p className="md:text-[12px] text-[9px] tracking-wide md:tracking-normal md:text-left py-2 px-4 hidden md:block  text-gray-500">
            Discover the difference of banking with BGS, where our values of
            integrity, respect, and excellence drive everything we do
          </p>
        </div>
        <div className="square  md:w-[25%] bg-[#F7F7F7] shadow-xl md:m-10 md:flex md:flex-col md:justify-center md:items-center md:p-6 p-2">
          <img
            src={s6}
            alt=""
            className="md:rounded-full w-[100px] h-[100px] rounded-full md:w-[200px] md:h-[200px] object-cover"
          />
          <h3 className="font-semibold mt-4 text-sm md:text-lg text-[#67c6e6]">
            Salary Mortgage Loan
          </h3>
          <p className="md:text-[12px] text-[9px] tracking-wide md:tracking-normal md:text-left py-2 px-4 hidden md:block  text-gray-500">
            Discover the difference of banking with BGS, where our values of
            integrity, respect, and excellence drive everything we do
          </p>
        </div>
      </div>
    </div>
  );
};
